import React, { useEffect, useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Input, Flex, Row, Col, Card, Modal, Typography } from "antd";
import { User } from "../Model/dbo/User";
import { useNavigate } from "react-router-dom";
import logo from '../Pics/logo.png'
import Cookies from "universal-cookie";
import { LoginStep1, LoginStep2 } from "../RestAPI/dbo/Loginapi";

const { Text } = Typography;

const Login: React.FC = () => {
  const [model, setModel] = useState<User>({
    Username: '',
    Password: '',
    UserId: 0,
    Token: '',
    PersonelNo: 0,
    Name: '',
    Unit: '',
    UnitId: 0,
    InsuranceNo: '',
    Job: '',
    IsManager: false,
    Code: 0,
    Mobile: '',
    saghfmorakhasi:0,
    uesedmorakhasi:'',
    remainingmorakhasi:0,
    hasServey:false
  });
  const [loading, setLoading] = useState(false);


  ///////
  const [isVisible, setIsVisible] = useState(false);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [timer, setTimer] = useState(0); // 3 minutes in seconds
  // const [code, setCode] = useState("");


  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    } else {
      setIsResendEnabled(true);
    }
  }, [timer]);





  const navigate = useNavigate()
  function checkUser() {
    var user = new Cookies().get('user');
    console.log(user)
    if (user) {
      return true;
    }
    return false;
  }
  async function signInStep1() {
    setLoading(true);
    var res = await LoginStep1(model.Mobile);
    if (res) {

      setTimer(180);
      setIsResendEnabled(false);
      setIsVisible(true);

    } else {
      alert("اطلاعات وارد شده صحیح نیست!")
    }
    setLoading(false);
  }

  async function signInStep2() {
    setLoading(true);
    var res = await LoginStep2(model.Mobile, model.Code);

    if (res && checkUser()) {
      navigate("/home")
      window.location.reload();
    } else {
      alert("اطلاعات وارد شده صحیح نیست!")
    }
    setLoading(false);
  }

  return (
    <>
      <div className="back-ground">
        <Row>
          <Col span={12} offset={1}>
            <div className="mar"></div>
          </Col>
        </Row>
        <Row justify="center" align="middle" >
          <Col span={12} offset={1}>
            <div className={`login-body ${loading ? "faded" : ""}`}>
              {loading && (
                <div className="loading-overlay logoLoading">
                  <img className="imgLoad" src={logo} />
                </div>
              )}
              <div className="back-ground-form">
                <Card >

                  <Form
                    name="ورود"
                    initialValues={{ remember: true }}
                    onFinish={signInStep1}
                  >
                    <Form.Item
                      name="Mobile"
                      label="شماره موبایل"
                      rules={[
                        { required: true, message: "لطفاً شماره موبایل خود را وارد کنید" },
                        {
                          pattern: /^(\+98|0)?9\d{9}$/,
                          message: "فرمت شماره موبایل معتبر نیست",
                        },
                      ]}
                    >
                      <Input
                        value={model?.Mobile}
                        onChange={(e) => setModel({ ...model, Mobile: e.target.value })}
                        prefix={<UserOutlined />}
                        placeholder="MOBILE_NUMBER"
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button block type="primary" htmlType="submit" >درخواست کد یکبار مصرف</Button>
                    </Form.Item>
                  </Form>

                </Card>
              </div>
            </div>
          </Col>
        </Row>
      </div>


      <Modal
        title="تأیید کد"
        open={isVisible}
        onCancel={() => setIsVisible(false)}
        footer={null}
        centered
      >
        <p>لطفاً کدی که به شماره شما ارسال شده است را وارد کنید:</p>
        <Input
          placeholder="کد ارسال شده"
          value={model.Code}
          onChange={(e) => setModel({ ...model, Code: Number(e.target.value) })}
          minLength={5}
          maxLength={7}
          style={{ marginBottom: 20 }}
        />
        <Button
          type="primary"
          block
          onClick={signInStep2}
          disabled={!model.Code}
        >
          ثبت کد
        </Button>
        <div style={{ marginTop: 20, textAlign: "center" }}>
          {isResendEnabled ? (
            <Button type="link" onClick={signInStep1}>
              ارسال مجدد کد
            </Button>
          ) : (
            <Text type="secondary">ارسال مجدد کد تا {Math.floor(timer / 60)}:{timer % 60} دقیقه دیگر فعال می‌شود.</Text>
          )}
        </div>
      </Modal>
    </>
  );
};

export default Login;
